import React, { useEffect, useState } from 'react';
import { sihirbazSecenekler, kampanyaOnizle, kampanyaOlustur, setOnizle, setOlustur, yerAra } from '../../services/reklamApi';
import './Yarat.css';

// YARAT — yeni kampanya ve yeni reklam seti sihirbazı (kullanıcı talebi: 2026-09-29).
//
// NEDEN SİHİRBAZ: Meta'da bir reklam seti kurmak onlarca alan ister (koordinat, yarıçap, yaş,
// cinsiyet, özel kitleler, hariç tutmalar, yerleşimler, sayfa, lead formu, optimizasyon hedefi,
// faturalandırma olayı, dönüşüm yeri). Kullanıcı bunların çoğunu bilmiyor ve bilmek zorunda da
// değil — hesapta zaten doğru kurulmuş setler var. Sorulan yalnızca DEĞİŞEN; kalanı en iyi
// eşleşen referans setten kopyalanır. Koordinat ve kitle tanımı UYDURULMAZ.
//
// İKİ AŞAMA: önce ÖNİZLE (ne yazılacağı gösterilir), sonra OLUŞTUR. Her ikisi de DURDURULMUŞ
// açılır — kullanıcı görmeden tek kuruş harcanmaz.
// HATA METNİ — API iki alan döndürür: "hata" (bizim genel cümlemiz) ve "mesaj" (Meta'nın
// kendi açıklaması, zaten Türkçe). Eskiden yalnız "hata" gösteriliyordu; kullanıcı ekranda
// "Meta'ya yazılamadı." dışında hiçbir şey göremiyordu (2026-09-30'da yakalandı).
function hataMetni(e) {
  const d = e?.response?.data;
  if (!d) return e?.message || 'Bilinmeyen hata.';
  const parcalar = [d.hata, d.mesaj].filter(Boolean);
  return parcalar.length ? parcalar.join(' ') : (e.message || 'Bilinmeyen hata.');
}

// META ÖN DENETİMİ (kullanıcı talebi: 2026-09-30) — önizleme artık "bence olur" demiyor.
// Backend, Meta'nın validate_only kipiyle isteği baştan sona denetletiyor ama HİÇBİR ŞEY
// yazmıyor. Meta reddederse oluştur düğmesi kapanır; sebep Meta'nın kendi Türkçe cümlesidir.
function MetaDenetimi({ onayladi, mesaj }) {
  if (onayladi === false) {
    return (
      <div className="yr-denetim yr-denetim-kotu">
        <b>✕ Meta bu hâliyle kabul etmiyor</b>
        <p>{mesaj || 'Meta bir sebep bildirmedi.'}</p>
        <small>Hiçbir şey yazılmadı. Düzeltmeden oluşturamazsın.</small>
      </div>
    );
  }
  if (onayladi === true) {
    return <div className="yr-denetim yr-denetim-iyi">✓ Meta ön denetimden geçirdi — yazmadan soruldu, kabul etti.</div>;
  }
  return null;   // denetim yapılamadıysa (ağ kopması) sessiz kal
}

export default function Yarat() {
  const [alt, setAlt] = useState('kampanya');       // kampanya | set
  const [sec, setSec] = useState(null);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');
  const [islemde, setIslemde] = useState(false);

  // --- kampanya formu ---
  const [kSube, setKSube] = useState('');
  const [kHizmet, setKHizmet] = useState('');
  const [kHedef, setKHedef] = useState('OUTCOME_LEADS');
  const [kYer, setKYer] = useState('Form');
  const [kOnizleme, setKOnizleme] = useState(null);
  // AD DÜZENLENEBİLİR (kullanıcı talebi: 2026-09-30) — "yeniyi açan vatandaş hangi kurala
  // uyması gerektiğini bir görsün, ama elle de değiştirebilsin". Seçimler değiştikçe kutu
  // kendiliğinden tazelenir; kullanıcı elle yazdığı anda tazeleme durur.
  const [kAd, setKAd] = useState('');
  const [kAdElle, setKAdElle] = useState(false);

  // --- set formu ---
  const [sKampanya, setSKampanya] = useState('');
  const [sKitle, setSKitle] = useState('GENIS');
  const [sSube, setSSube] = useState('');
  const [sHizmet, setSHizmet] = useState('');
  const [sButce, setSButce] = useState(250);
  const [sOnizleme, setSOnizleme] = useState(null);
  const [sAd, setSAd] = useState('');            // önizlemeden gelir, elle değiştirilebilir

  // KONUM SEÇİMİ (kullanıcı kararı: 2026-09-30) — Meta'nın kendi yer veritabanından.
  // Meta koordinat vermiyor; o yüzden liste seçiminde Meta'nın yer kimliği hedefleniyor.
  //
  // YARIÇAP KURALLARI — Meta'nın doğrulama ucunda ölçüldü (30.09.2026), tahmin değil:
  //   ilçe (medium_geo_area / subcity / neighborhood) → yarıçap REDDEDİLİR
  //     ("Normalization does not allow the value radius") — idari sınır olarak hedeflenir
  //   şehir (city) → yarıçap zorunlu değil ama verilirse 17-80 km arasında olmalı (15 km reddedildi)
  //   harita pini (custom_location) → 1 km'ye kadar iner
  // Dar çember isteniyorsa TEK YOL pindir; aşağıdaki pin kutusu bunun için var.
  const [yerMetin, setYerMetin] = useState('');
  const [yerSonuc, setYerSonuc] = useState([]);
  const [yerArıyor, setYerArıyor] = useState(false);
  const [secilenYerler, setSecilenYerler] = useState([]);
  const [sadeceIstanbul, setSadeceIstanbul] = useState(true);

  const yerAramaYap = () => {
    if (yerMetin.trim().length < 2) return;
    setYerArıyor(true); setHata('');
    yerAra(yerMetin.trim(), sadeceIstanbul ? '3683' : undefined)
      .then(r => setYerSonuc(r.data?.yerler || []))
      .catch(e => setHata(hataMetni(e)))
      .finally(() => setYerArıyor(false));
  };

  const yerEkle = (y) => {
    if (secilenYerler.some(x => x.anahtar === y.anahtar)) return;
    setSecilenYerler(l => [...l, { ...y, yaricapKm: y.yaricapDestekler ? 20 : null }]);
    setYerSonuc([]); setYerMetin('');
  };

  // HARİTA PİNİ — Meta'nın listesinde olmayan yerler (Mimaroba, Caddebostan, Bahçeşehir) ve
  // dar çember isteyen durumlar için. Meta'da ölçüldü (2026-09-30): pin 1 km'ye iner.
  const [pinKoord, setPinKoord] = useState('');
  const [pinAd, setPinAd] = useState('');
  const [pinKm, setPinKm] = useState(3);
  const [pinHata, setPinHata] = useState('');

  const pinEkle = () => {
    setPinHata('');
    // Google Maps "41.0082, 28.9784" biçiminde verir; noktalı virgül/boşluk da kabul edilsin.
    const p = pinKoord.trim().replace(/;/g, ',').split(',').map(s => s.trim()).filter(Boolean);
    const enlem = Number(p[0]); const boylam = Number(p[1]);
    if (p.length !== 2 || !isFinite(enlem) || !isFinite(boylam)) {
      setPinHata('Koordinatı "41.0082, 28.9784" biçiminde yapıştır.'); return;
    }
    if (enlem < -90 || enlem > 90 || boylam < -180 || boylam > 180) {
      setPinHata('Enlem -90..90, boylam -180..180 aralığında olmalı — sıra ters olabilir.'); return;
    }
    const km = Math.min(80, Math.max(1, Number(pinKm) || 3));
    const anahtar = `pin:${enlem},${boylam}`;
    if (secilenYerler.some(x => x.anahtar === anahtar)) { setPinHata('Bu pin zaten ekli.'); return; }

    setSecilenYerler(l => [...l, {
      anahtar, tip: 'pin', tipAdi: 'harita pini', yaricapDestekler: true,
      ad: pinAd.trim() || `${enlem}, ${boylam}`, yaricapKm: km, enlem, boylam,
    }]);
    setPinKoord(''); setPinAd('');
  };

  // Kampanya adı seçimlere göre tazelenir — kullanıcı elle yazmadıysa.
  useEffect(() => {
    if (!kAdElle) setKAd(`${kSube} | ${kHizmet} | ${kYer}`);
  }, [kSube, kHizmet, kYer, kAdElle]);

  useEffect(() => {
    sihirbazSecenekler()
      .then(r => {
        setSec(r.data);
        if (r.data?.subeler?.length) { setKSube(r.data.subeler[0]); setSSube(r.data.subeler[0]); }
        if (r.data?.hizmetler?.length) { setKHizmet(r.data.hizmetler[0]); setSHizmet(r.data.hizmetler[0]); }
      })
      .catch(e => setHata(hataMetni(e)));
  }, []);

  const temizle = () => { setHata(''); setBilgi(''); };

  const kOnizle = () => {
    temizle(); setIslemde(true);
    kampanyaOnizle({ sube: kSube, hizmet: kHizmet, hedef: kHedef, donusumYeri: kYer, ad: kAd })
      .then(r => setKOnizleme(r.data))
      .catch(e => setHata(hataMetni(e)))
      .finally(() => setIslemde(false));
  };

  const kYarat = () => {
    temizle(); setIslemde(true);
    kampanyaOlustur({ sube: kSube, hizmet: kHizmet, hedef: kHedef, donusumYeri: kYer, ad: kAd })
      .then(r => { setBilgi(`Kampanya oluşturuldu: "${r.data.ad}" — DURDURULMUŞ. Hesap Yapısı'ndan görebilirsin.`); setKOnizleme(null); })
      .catch(e => setHata(hataMetni(e)))
      .finally(() => setIslemde(false));
  };

  const sOnizle = () => {
    temizle(); setIslemde(true);
    setOnizle({ kampanyaId: sKampanya, kitleTipi: sKitle, sube: sSube, hizmet: sHizmet, gunlukTl: Number(sButce), yerler: secilenYerler.map(y => ({ anahtar: y.anahtar, ad: y.ad, tip: y.tip, yaricapKm: y.yaricapKm, enlem: y.enlem, boylam: y.boylam })) })
      .then(r => { setSOnizleme(r.data); setSAd(r.data?.yeniAd || ""); if (r.data?.hata) setHata(r.data.hata); })
      .catch(e => setHata(hataMetni(e)))
      .finally(() => setIslemde(false));
  };

  const sYarat = () => {
    temizle(); setIslemde(true);
    setOlustur({ kampanyaId: sKampanya, kitleTipi: sKitle, sube: sSube, hizmet: sHizmet, gunlukTl: Number(sButce), ad: sAd, yerler: secilenYerler.map(y => ({ anahtar: y.anahtar, ad: y.ad, tip: y.tip, yaricapKm: y.yaricapKm, enlem: y.enlem, boylam: y.boylam })) })
      .then(r => { setBilgi(`Reklam seti oluşturuldu: "${r.data.ad}" — DURDURULMUŞ. İçine reklam eklemeden yayına alma.`); setSOnizleme(null); })
      .catch(e => setHata(hataMetni(e)))
      .finally(() => setIslemde(false));
  };

  if (!sec && !hata) return <div className="loading">Seçenekler yükleniyor...</div>;

  return (
    <div className="yr">
      <div className="yr-sekmeler">
        <button className={alt === 'kampanya' ? 'aktif' : ''} onClick={() => { setAlt('kampanya'); temizle(); }}>
          Kampanya Yarat
        </button>
        <button className={alt === 'set' ? 'aktif' : ''} onClick={() => { setAlt('set'); temizle(); }}>
          Reklam Seti Yarat
        </button>
      </div>

      {hata && <div className="hata-kutu">{hata}</div>}
      {bilgi && <div className="basari-kutu">{bilgi}</div>}

      {/* ============================ KAMPANYA ============================ */}
      {alt === 'kampanya' && (
        <>
          <p className="yr-not">
            Kampanya sadece bir <b>kap</b>: hedefi ve adı tutar. Bütçe, hedef kitle ve coğrafya
            burada değil, açacağın <b>reklam setlerinde</b> tanımlanır.
          </p>

          <div className="yr-form">
            <label>Şube / kapsam
              <select value={kSube} onChange={e => setKSube(e.target.value)}>
                {sec?.subeler?.map(x => <option key={x} value={x}>{x}</option>)}
              </select>
            </label>
            <label>Hizmet
              <select value={kHizmet} onChange={e => setKHizmet(e.target.value)}>
                {sec?.hizmetler?.map(x => <option key={x} value={x}>{x}</option>)}
              </select>
            </label>
            <label>Hedef <small>(sonradan değiştirilemez)</small>
              <select value={kHedef} onChange={e => setKHedef(e.target.value)}>
                {sec?.hedefler?.map(x => <option key={x.kod} value={x.kod}>{x.ad}</option>)}
              </select>
            </label>
            <label>Dönüşüm yeri <small>(sadece ad için)</small>
              <select value={kYer} onChange={e => setKYer(e.target.value)}>
                <option value="Form">Form</option>
                <option value="WhatsApp">WhatsApp</option>
                <option value="Site">Site</option>
                <option value="Arama">Arama</option>
              </select>
            </label>
          </div>

          {/* Ad DÜZENLENEBİLİR kutuda (kullanıcı talebi: 2026-09-30): yeni kampanya açan kişi
              isimlendirme kuralını burada görür. Elle yazınca otomatik tazeleme durur. */}
          <label className="yr-ad">Kampanya adı
            <input value={kAd} onChange={e => { setKAd(e.target.value); setKAdElle(true); }} />
            <small>
              Kural: <code>ŞUBE | Hizmet | Dönüşüm yeri</code> — örnek <code>SANCAKTEPE | Diz | Form</code>.
              Yukarıdaki seçimlere göre kendiliğinden yazılır; istersen değiştir.
              {kAdElle && <> <button type="button" className="yr-sifirla"
                onClick={() => setKAdElle(false)}>kurala geri dön</button></>}
            </small>
          </label>

          <div className="yr-dugmeler">
            <button className="yr-onizle" onClick={kOnizle} disabled={islemde}>Önizle</button>
          </div>

          {kOnizleme && (
            <div className="yr-onizleme">
              <h4>Oluşturulacak kampanya</h4>
              <div className="yr-satir"><span>Adı</span><b>{kOnizleme.ad}</b></div>
              <div className="yr-satir"><span>Hedef</span><b>{kOnizleme.hedef}</b></div>
              <div className="yr-satir"><span>Durum</span><b>DURDURULMUŞ</b></div>
              <ul className="yr-notlar">{kOnizleme.notlar?.map((n, i) => <li key={i}>{n}</li>)}</ul>
              <MetaDenetimi onayladi={kOnizleme.metaOnayladi} mesaj={kOnizleme.metaMesaji} />
              <button className="yr-yarat" onClick={kYarat} disabled={islemde || kOnizleme.metaOnayladi === false}>
                ✓ Kampanyayı oluştur
              </button>
            </div>
          )}
        </>
      )}

      {/* ============================ REKLAM SETİ ============================ */}
      {alt === 'set' && (
        <>
          <p className="yr-not">
            Koordinat, yaş, kitle ve hariç tutmalar <b>uydurulmaz</b> — seçtiğin şube ve hizmete en
            uygun <b>çalışan setten</b> kopyalanır. Aşağıda tam olarak ne yazılacağını görürsün.
          </p>

          <div className="yr-form">
            <label>Hangi kampanyaya?
              <select value={sKampanya} onChange={e => setSKampanya(e.target.value)}>
                <option value="">— seçiniz —</option>
                {sec?.kampanyalar?.map(k => <option key={k.id} value={k.id}>{k.ad}</option>)}
              </select>
            </label>
            <label>Kitle tipi
              <select value={sKitle} onChange={e => setSKitle(e.target.value)}>
                {sec?.kitleTipleri?.map(x => <option key={x.kod} value={x.kod}>{x.ad}</option>)}
              </select>
            </label>
            <label>Hangi şube çevresi? <small>(aşağıda konum seçmezsen coğrafya buradan kopyalanır)</small>
              <select value={sSube} onChange={e => setSSube(e.target.value)}>
                {sec?.subeler?.map(x => <option key={x} value={x}>{x}</option>)}
              </select>
            </label>
            <label>Hangi hizmet? <small>(yeniden hedeflemede kitleleri bu belirler)</small>
              <select value={sHizmet} onChange={e => setSHizmet(e.target.value)}>
                {sec?.hizmetler?.map(x => <option key={x} value={x}>{x}</option>)}
              </select>
            </label>
            <label>Günlük bütçe (₺)
              <input type="number" min="100" step="50" value={sButce} onChange={e => setSButce(e.target.value)} />
            </label>
          </div>

          {/* KONUM SEÇİCİ (kullanıcı kararı: 2026-09-30) — Meta'nın kendi yer veritabanı.
              Meta koordinat vermediği için pin değil, Meta'nın yer kimliği hedefleniyor. */}
          <div className="yr-konum">
            <div className="yr-konum-bas">
              <b>Konum</b>
              <label className="yr-ist">
                <input type="checkbox" checked={sadeceIstanbul} onChange={e => setSadeceIstanbul(e.target.checked)} />
                sadece İstanbul
              </label>
            </div>

            <div className="yr-konum-ara">
              <input placeholder="İlçe / semt ara — örn. Kadıköy, Pendik, Mecidiyeköy"
                     value={yerMetin}
                     onChange={e => setYerMetin(e.target.value)}
                     onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); yerAramaYap(); } }} />
              <button type="button" onClick={yerAramaYap} disabled={yerArıyor || yerMetin.trim().length < 2}>
                {yerArıyor ? 'aranıyor...' : 'Ara'}
              </button>
            </div>

            {yerSonuc.length > 0 && (
              <ul className="yr-konum-sonuc">
                {yerSonuc.slice(0, 40).map(y => (
                  <li key={y.anahtar} onClick={() => yerEkle(y)}>
                    <b>{y.ad}</b>
                    <span>{y.tipAdi}{y.bolge ? ` · ${y.bolge}` : ''}</span>
                  </li>
                ))}
              </ul>
            )}

            {/* HARİTA PİNİ — Meta'nın yer listesinde olmayan yerler (Mimaroba, Caddebostan,
                Bahçeşehir) ve dar çember isteyen durumlar için tek yol. 30.09.2026'da Meta'nın
                doğrulama ucunda ölçüldü: pin 1 km'ye iner, ilçeye yarıçap verilemez, şehirde
                alt sınır 17 km. */}
            <div className="yr-pin">
              <div className="yr-pin-bas">
                <b>Harita pini</b>
                <small>Google Maps'te yere sağ tıkla → koordinatı kopyala → buraya yapıştır</small>
              </div>
              <div className="yr-pin-ara">
                <input placeholder="41.0082, 28.9784"
                       value={pinKoord}
                       onChange={e => setPinKoord(e.target.value)}
                       onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); pinEkle(); } }} />
                <input placeholder="Ad (isteğe bağlı) — örn. Mimaroba"
                       value={pinAd} onChange={e => setPinAd(e.target.value)} />
                <input type="number" min="1" max="80" value={pinKm}
                       onChange={e => setPinKm(e.target.value)} title="yarıçap (km)" />
                <span>km</span>
                <button type="button" onClick={pinEkle}>Ekle</button>
              </div>
              {pinHata && <p className="yr-pin-hata">{pinHata}</p>}
            </div>

            {secilenYerler.length === 0 ? (
              <p className="yr-konum-bos">
                Seçim yapmazsan coğrafya, <b>{sSube}</b> şubesinin çalışan setinden kopyalanır.
              </p>
            ) : (
              <ul className="yr-konum-secili">
                {secilenYerler.map(y => (
                  <li key={y.anahtar} className={y.tip === 'pin' ? 'yr-pinli' : undefined}>
                    <b>{y.tip === 'pin' ? `📍 ${y.ad}` : y.ad}</b>
                    <span>{y.tipAdi}</span>
                    {(y.tip === 'pin' || y.yaricapDestekler) ? (
                      <label>yarıçap
                        <input type="number" min={y.tip === 'pin' ? 1 : 17} max="80"
                               value={y.yaricapKm ?? (y.tip === 'pin' ? 3 : 20)}
                               onChange={e => setSecilenYerler(l => l.map(x =>
                                 x.anahtar === y.anahtar ? { ...x, yaricapKm: Number(e.target.value) } : x))} />
                        km
                      </label>
                    ) : <em>idari sınır — Meta yarıçap kabul etmiyor</em>}
                    <button type="button" onClick={() => setSecilenYerler(l => l.filter(x => x.anahtar !== y.anahtar))}>✕</button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="yr-dugmeler">
            <button className="yr-onizle" onClick={sOnizle} disabled={islemde || !sKampanya}>Önizle</button>
          </div>

          {sOnizleme && !sOnizleme.hata && (
            <div className="yr-onizleme">
              <h4>Oluşturulacak reklam seti</h4>

              {/* Set adı da DÜZENLENEBİLİR (kullanıcı talebi: 2026-09-30). Kural coğrafyadan
                  türetilir; kullanıcı isterse değiştirir. */}
              <label className="yr-ad">Set adı
                <input value={sAd} onChange={e => setSAd(e.target.value)} />
                <small>
                  Kural: <code>KİTLE | Coğrafya</code> — örnek <code>GENİŞ | 3 bölge · 8km</code>.
                  Şube ve hizmet kampanya adında zaten yazıyor, burada tekrarlanmaz.
                  {sAd !== sOnizleme.yeniAd && <> <button type="button" className="yr-sifirla"
                    onClick={() => setSAd(sOnizleme.yeniAd || '')}>kurala geri dön</button></>}
                </small>
              </label>

              <div className="yr-satir"><span>Kampanya</span><b>{sOnizleme.kampanyaAdi}</b></div>
              <div className="yr-satir"><span>Günlük bütçe</span><b>{sOnizleme.gunlukTl} ₺</b></div>
              <div className="yr-satir"><span>Durum</span><b>DURDURULMUŞ</b></div>

              <div className="yr-kaynak">
                Ayarlar şu setten kopyalanıyor: <b>{sOnizleme.referansKampanya} → {sOnizleme.referansSetAdi}</b>
              </div>

              <div className="yr-satir"><span>Coğrafya</span><b>{sOnizleme.cografyaOzeti}</b></div>
              <div className="yr-kucuk">{sOnizleme.cografyaKaynagi}</div>
              <div className="yr-satir"><span>Yaş</span><b>{sOnizleme.yasAraligi}</b></div>
              <div className="yr-satir"><span>Yerleşim</span><b>{sOnizleme.yerlesim}</b></div>
              <div className="yr-satir"><span>Optimizasyon</span><b>{sOnizleme.optimizasyonHedefi}</b></div>
              <div className="yr-satir"><span>Dönüşüm yeri</span><b>{sOnizleme.donusumYeri || '—'}</b></div>
              {/* Lead formu SETTE değil, reklamın kreatifinde yaşıyor (ölçüldü 2026-09-29:
                  29 aktif setin promoted_object alanında yalnızca sayfa var). Burada sayfa
                  gösterilir; form, sete reklam eklerken gelir. */}
              <div className="yr-satir"><span>Facebook sayfası</span><b>{sOnizleme.sayfaId || '—'}</b></div>
              <div className="yr-kucuk">Lead formu sette değil; sete ekleyeceğin reklamla birlikte gelir.</div>

              {sOnizleme.ozelKitleler?.length > 0 && (
                <div className="yr-liste"><span>Hedeflenen kitleler</span>
                  <ul>{sOnizleme.ozelKitleler.map((x, i) => <li key={i}>{x}</li>)}</ul>
                </div>
              )}
              {sOnizleme.haricTutulan?.length > 0 && (
                <div className="yr-liste"><span>Hariç tutulanlar</span>
                  <ul>{sOnizleme.haricTutulan.map((x, i) => <li key={i}>{x}</li>)}</ul>
                </div>
              )}

              {sOnizleme.uyarilar?.length > 0 && (
                <div className="yr-uyari">
                  {sOnizleme.uyarilar.map((u, i) => <div key={i}>⚠️ {u}</div>)}
                </div>
              )}

              <MetaDenetimi onayladi={sOnizleme.metaOnayladi} mesaj={sOnizleme.metaMesaji} />
              <button className="yr-yarat" onClick={sYarat} disabled={islemde || sOnizleme.metaOnayladi === false}>
                ✓ Reklam setini oluştur
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
